<nav
  class="left-navigation"
  [class.left-navigation--expanded]="isExpanded"
  aria-label="Main navigation"
  (mouseenter)="expand()"
  (mouseleave)="collapse()"
>
  <div class="left-navigation__brand" aria-hidden="true">
    <img src="assets/images/postnord.svg" class="left-navigation__brand-logo" alt="" />
  </div>
  <ul class="left-navigation__list">
    @for (item of items; track item.routerLink ?? item.label) {
      @if (item.visible !== false) {
        <li class="left-navigation__item">
          <a
            class="left-navigation__link"
            [routerLink]="item.routerLink"
            routerLinkActive="left-navigation__link--active"
            [routerLinkActiveOptions]="{ exact: true }"
            ariaCurrentWhenActive="page"
            [attr.aria-label]="item.label"
            [pTooltip]="item.label ?? ''"
            tooltipPosition="right"
            [tooltipDisabled]="isExpanded"
          >
            <i class="left-navigation__icon" [class]="item.icon" aria-hidden="true"></i>
            <span class="left-navigation__label">{{ item.label }}</span>
            @if (item.items?.length) {
              <i class="pi pi-chevron-right left-navigation__indicator" aria-hidden="true"></i>
            }
          </a>

          @if (item.items?.length && isExpanded) {
            <ul class="left-navigation__submenu">
              @for (child of item.items; track child.routerLink ?? child.label) {
                @if (child.visible !== false) {
                  <li>
                    <a
                      class="left-navigation__link left-navigation__link--child"
                      [routerLink]="child.routerLink"
                      routerLinkActive="left-navigation__link--active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      ariaCurrentWhenActive="page"
                    >
                      <i class="left-navigation__icon" [class]="child.icon" aria-hidden="true"></i>
                      <span class="left-navigation__label">{{ child.label }}</span>
                    </a>
                  </li>
                }
              }
            </ul>
          }
        </li>
      }
    }
  </ul>

  @if (profileName) {
    <div class="left-navigation__profile" [attr.aria-label]="'Signed in as ' + profileName">
      <span class="left-navigation__avatar" aria-hidden="true">{{ initials }}</span>
      <span class="left-navigation__profile-details">
        <strong class="left-navigation__profile-name">{{ userDisplayName.replace('PostNord', '') }}</strong>
        @if (userName && userName !== profileName) {
          <span class="left-navigation__profile-email">{{ userName }}</span>
        }
      </span>
    </div>
  }
</nav>